<template>
	<contentBox v-if="!loadError" v-bind:loading="!permitLoaded" mainId="permit">
		<contentTitle v-if="permit" label="PERMIT" v-bind:close="routeClose">
			<h2 class="text-white font-weight-light pb-2">{{permit.typeRaw}}</h2>
		</contentTitle>
		<contentBody v-if="permit">
			<contentActions v-if="permit">
				<button class="btn btn-outline-light btn-sm" v-bind:class="{active:shareShown === true}" v-on:click="share">
					<i class="material-icons md-18" title="center map on zoning">share</i> 
					Share
				</button>
				<button class="btn btn-outline-light btn-sm" v-on:click="zoomTo">
					<i class="material-icons md-18" title="center map on zoning">place</i> 
					Center
				</button>
			</contentActions>
			<share v-if="shareShown" v-bind:link="location" @close="share"></share>
			<div class="p-3">
				<div class="category-body">
					<div class="category">
						<div class="category-title">DETAILS</div>
						<div v-if="permit.projectName !== null" class="property-row">
							<label>Project name</label>
							<div class="property-value-right">
								{{permit.projectName}}
							</div>
						</div>
						<div class="property-row" v-if="permit.projectId !== null">
							<label>Project ID</label>
							<div class="property-value-right">
								{{permit.projectId}}
							</div>
						</div>
						<div class="property-row" v-if="permit.contractor && permit.contractor.companyName !== null">
							<label>Contractor</label>
							<div class="property-value-right">
								{{permit.contractor.companyName}}
							</div>
						</div>
														
						<div v-if="validDate(permit.appliedDate)" class="property-row">
							<label>Applied</label>
							<div class="property-value-right">
								{{permit.appliedDate | longDate}}
							</div>
						</div>
						<div v-if="validDate(permit.issuedDate)" class="property-row">
							<label>Issued</label>
							<div class="property-value-right">
								{{permit.issuedDate | longDate}}
							</div>
						</div>
						<div v-if="validDate(permit.completedDate)" class="property-row">
							<label>Completed</label>
							<div class="property-value-right">
								{{permit.completedDate | longDate}}
							</div>
						</div>
					</div>

					<div v-if="permit.description !== null" class="category">
						<div class="category-title">DESCRIPTION</div>
						<div v-if="!permit.unlocked && parcel" v-on:click="unlockParcel" class="lock-block mt-2 mb-2">
							<div class="lock-icon-box">
								<i class="material-icons md-36">lock</i>
							</div>
							<div class="lock-text">
								<h5 class="mb-0 text-white">Unlock to view permit description</h5>
								<h5 class="mb-0 font-weight-light text-light">${{plans.parcelUnlock.price}} to unlock all info for this permit's parcel</h5>
							</div>
						</div>
						<div v-else-if="!permit.unlocked" v-on:click="unlock" class="lock-block mt-2 mb-2">
							<div class="lock-icon-box">
								<i class="material-icons md-36">lock</i>
							</div>
							<div class="lock-text">
								<h5 class="mb-0 text-white">Unlock to view permit description</h5>
								<h5 class="mb-0 font-weight-light text-light">${{plans.dayPass.price}} to unlock all info on Scoutred for 24 hours</h5>
							</div>
						</div>
						<div v-else class="property-row">
							<div class="text-description">{{permit.description}}</div>
						</div>
					</div>

					<div v-if="permit.jurisdictionPermitId" class="category">
						<div class="category-title">REFERENCES</div>
						<div class="property-row">
							<label class="mb-0 font-weight-light">Source</label>
							<div class="property-value-right">

								<a target="_blank" v-if="this.permit && this.permit.link" 
									v-bind:href="jurisdictionPermitURL(this.permit)">
									#{{this.permit.jurisdictionPermitId}}
									<i class="material-icons md-12">open_in_new</i>
								</a>
								<span v-else>#{{this.permit.jurisdictionPermitId}}</span>
							</div>
						</div>
					</div>

					<div v-if="parcel" class="category">
						<div class="category-title">PARCEL</div>
						<div class="property-row">
							<label>Address</label>
							<div class="property-value-right">
								{{parcel | address}}
							</div>
						</div>
						<div class="property-row pt-0">
							<div class="property-value-right">
								{{parcelSub}}
							</div>
						</div>
						<div class="property-row" v-if="permit.apnFmt !== null">
							<label>APN</label>
							<div class="property-value-right">
								<a href="javascript:" v-on:click="parcelGo($event,permit.parcelId)">
									{{parcel.apnFmt}}
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div>
				<div v-if="permitsOther && permitsOther.length > 0" class="bg-light p-2 pb-3">
					<div class="pt-1 mx-2 pb-2 font-weight-bold font-12 text-light-gray">OTHER PERMITS FROM THIS PARCEL ({{permitsOther.length}})</div>

					<div class="card mb-2 p-2 pb-3" 
						v-on:click="permitClick($event,permit)"	
						v-for="(permit, index) in permitsOther">

						<div class="category-title text-uppercase">
							{{permit.typeRaw}} 
							<sup class="text-red" v-if="getStatusIsNew(permit)">New</sup>
							<span class="float-right">
								<a :href="jurisdictionPermitURL(permit)" target="_blank">
									#{{permit.jurisdictionPermitId}}
									<i class="material-icons md-12">open_in_new</i>
								</a>
							</span>
						</div>
						<div class="pt-2">
							<div class="property-row" v-if="parcel && parcel.apnFmt">
								<label>Parcel APN</label>
								<div class="property-value-right">
									<a href="javascript:" v-on:click="parcelGo($event,permit.parcelId)">
										{{parcel.apnFmt}}
									</a>
								</div>
							</div>
							<div class="property-row" v-if="permit.projectName !== null">
								<label>Project name</label>
								<div class="property-value-right">
									{{permit.projectName}}
								</div>
							</div>
							<div class="property-row" v-if="permit.projectId !== null">
								<label>Project ID</label>
								<div class="property-value-right">
									{{permit.projectId}}
								</div>
							</div>
							<div class="property-row" v-if="permit.contractor && permit.contractor.companyName !== null">
								<label>Contractor</label>
								<div class="property-value-right">
									{{permit.contractor.companyName}}
								</div>
							</div>
							<div class="property-row">
								<label>Status</label>
								<div class="property-value-right">
									{{getStatus(permit)}} on {{getStatusDate(permit)}}</td>
								</div>
							</div>
							<div class="property-row" v-if="permit.description !== null">
								<div class="text-description">{{descriptionShort(permit.description)}}</div>
							</div>
						</div>
					</div>
				</div>

			</div>
		</contentBody>
	</contentBox>
</template>

<script>

import contentBox from '../content';
import contentActions from '../content/content-actions';
import contentBody from '../content/content-body';
import contentTitle from '../content/content-title';
import share from '../share/share';

const millsecondsIsNew = 1000*60*60*24*90;

export default {
	name: 'permit',

	props:{
		id: Number
	},

	components:{
		contentBox,
		contentActions,
		contentBody,
		contentTitle,
		share
	},

	computed: {
		token: function(){
			return this.$store.state.agent.token;
		},
		permit: function() {
			return this.$store.state.permit.rec;
		},
		parcel: function() {
			return this.$store.state.parcel.rec;
		},
		parcelSub:function(){
			let str = '',
				parcel = this.parcel;
			if (parcel.address){
				if (parcel.address.jurisdiction !== null) str += parcel.address.jurisdiction+', ';
				if (parcel.address.state !== null) str += parcel.address.state+' ';
				if (parcel.address.postal !== null) str += parcel.address.postal;
			}
			return str;
		},
		plans:function(){
			return this.$store.state.plan.plans;
		},
		mapLoaded: function(){
			return this.$store.state.map.loaded;
		},
		searchTerm:function(){
			return this.$store.state.search.term;
		},
		location:function(){
			return window.location.href;
		}
	},

	data: function(){
		return {
			permitsOther:null,
			permitLoaded:false,
			parcelLoaded:false,
			shareShown:false,
			loadError:null
		}
	},

	created: function(){
		this.getRec();
	},

	destroyed: function(){
		this.$store.dispatch('MAP_FEATURE_ACTIVE_SET', null);	
	},

	methods: {
		request:function(){
			this.getRec();
		},
		getRec: function(){
			this.permitLoaded = false;
			this.parcelLoaded = false;
			this.loadError = null;
			this.$store.dispatch('PERMIT_GET', {
				id: this.id
			}).catch((error)=>{
				this.loadError = error;
			});			
		},
		routeClose:function(){
			if (this.searchTerm){
				this.$router.push({
					name: 'permitsSearch', 
					params:{search:this.searchTerm}
				});
				return;
			}
			this.$router.push({
				name: 'permits', 
				params:{}
			});
		},
		zoomTo:function(){
			this.$store.dispatch('PERMIT_ZOOM_TO',{
				permit:this.permit
			});
		},
		parcelGo:function(e,parcelId){
			const route = {
				name: 'parcels', 
				params:{
					id: parcelId
				}
			};
			this.$router.push(route);
			e.stopPropagation();
			return false;
		},
		parcelURL: function(id){
			if (!id){
				return false;
			}
			return "/parcels/"+id;
		},
		getRecsOther:function(){

			let query = (this.permit.apn)? this.permit.apn: this.permit.projectId;
			this.$store.dispatch('SEARCH', {
				query: query,
				type:'permit',
				doEmptySearch:true
			}).then((data)=>{
				let results = data.permits.filter((permit)=>{
					if (permit.id !== this.permit.id) return true;
					return false;
				})

	         this.$data.permitsOther = results;
			}).catch((e)=>{
				console.error(e);
			});
		},

		getStatus:function(permit){
			if (this.validDate(permit.completedDate)){
				return 'Completed';
			}
			if (this.validDate(permit.issuedDate)){
				return 'Issued';
			}
			if (this.validDate(permit.appliedDate)){
				return 'Applied';
			}
		},
		getStatusLast:function(permit){
			if (this.validDate(permit.completedDate)){
				return permit.completedDate;
			}
			if (this.validDate(permit.issuedDate)){
				return permit.issuedDate;
			}
			if (this.validDate(permit.appliedDate)){
				return permit.appliedDate;
			}
		},
		getStatusDate:function(permit){
			return this.formatDate(this.getStatusLast(permit));
		},
		getStatusIsNew:function(permit){
			return this.isNew(this.getStatusLast(permit));
		},
		validDate:function(dateStr){
			try{
				var d = new Date(dateStr);
				if (d.getUTCFullYear() == 1){
					return false;
				}
				return true;
			} catch(e){
				return false;
			}
		},
		formatDate: function(dateStr){
			if (!dateStr){
				return ""
			}
			var d = new Date(dateStr);

			//	sniffing for invalid dates
			if (d.getUTCFullYear() == 1){
				return ""
			}

			//	format our datestring
			return (d.getUTCMonth()+1) +"/"+ d.getUTCDate() + "/" + d.getUTCFullYear();
		},

		//	check if a date is new
		isNew: function(dateStr){
			if (!dateStr){
				return ""
			}
			let d = new Date(dateStr);
			let today = new Date();

			//	get date diff to determine "new"
			if ((today - d) < millsecondsIsNew){
				return true;
			}
			return false;
		},

		jurisdictionPermitURL: function(permit){
			return permit.link;
		},

		poiSet: function(){
			if (!this.permit) return;

			const feature = {
				id:this.permit.id,
				source:'poi'
			};

			this.$store.dispatch('MAP_FEATURE_ACTIVE_SET', feature);
		},
		permitClick:function(e, permit){
			const route = {
				name: 'permit', 
				params:{
					id: permit.id
				}
			};
			this.$router.push(route);
		},
		updateTitleTag:function(){
			document.title = this.permit.typeRaw+' - Scoutred Maps';
		},
		share:function(){
			if (this.shareShown){
				this.shareShown = false;
				return;
			}
			if (navigator.share){
				navigator.share({
				  title: this.permit.typeRaw+' - Scoutred Maps',
				  text: 'Permit data for '+this.permit.typeRaw+' on parcel '+this.parcelTitle,
				  url: window.location.href,
				});
				return;
			}

			this.shareShown = true;
		},
		descriptionShort:function(description){
			if (description && description.length > 150){
				return description.substr(0,150)+'...';
			}
		},
		unlock: function(){
			this.$router.push({
				name: 'unlock', 
				params:{},
				query:{}
			});
		},
		unlockParcel: function(){
			this.$router.push({
				name: 'unlock-parcel', 
				params:{
					parcelId: this.parcel.id
				},
				query:{}
			});
		},
	},

	watch: {
		id:function(oldId, newId){
			if (oldId === newId) return;
			this.$store.dispatch('SCROLL_CONTENT_TOP');
			this.getRec();
		},
		permit:function(rec){
			if (!rec) return;
			if (rec.parcelId) this.$store.dispatch('PARCEL_GET', {
				id: rec.parcelId
			});		
			this.getRecsOther();

			this.$data.permitLoaded = true;
			
			if (this.mapLoaded) this.poiSet();
			this.updateTitleTag();
		},
		parcel:function(rec){
			if (!rec) return;

			this.$data.parcelLoaded = true;
		},
		mapLoaded:function(){
			if (this.permit) this.poiSet();
		}
	},
}

</script>
<style>
.options i{
	cursor:pointer;
	color:#868e96;
}
.options i:hover{
	color:#FFFFFF;
}
.options i.green{
	color:#679E38;
}
.options i.green:hover{
	color:#7CB341;
}

.lock-block{
	margin-bottom:1rem;
	background-color:#37474F;
	cursor:pointer;
	overflow:hidden;
	border-radius:4px;
	color:#FFF;
}
.lock-block:hover{
	background-color:#273237;
}
.lock-icon-box{
	width:25%;
	float:left;
	text-align:right;
	line-height:65px;
	padding-right:20px;
}
.lock-text{
	width:75%;
	float:left;
	padding:1rem 1rem 1rem 0;
}

.line-height-locked{
	line-height:70px;
}
.mt-updated{
	margin-top:3px;
}
.nav-link{
	cursor:pointer;
	color:#CCC;
}
.nav-link:hover{
	color:#EEE;
}
#permit h2{
	margin-top:-6px;
	font-size:26px;
	line-height:30px;
}
#permit .nav-link{
	padding:0.4rem 0.5rem;
}

#permit h5{
	font-size:14px;
	line-height:18px;
}
#permit .field-row{
	font-size:14px;
	line-height:24px;
}
#permit .card{
	cursor:pointer;
	background-color:rgba(255,255,255,0);
}
#permit .highlight,#permit .card:hover{
	background-color:rgba(255,255,255,1);
}

</style>


// WEBPACK FOOTER //
// src/components/permit/permit-full.vue